/**
 * Created by Bimal James on 2014-09-15.
 * I dont think this is used anywhere
 */
define('all/player/uk-ageverify',['jquery'], function($) {
    'use strict';
    function verifyAgeForUKPlayer(amount, currency, paymentmethod, callback) {
        $.ajaxSetup({
            async: false
        });
        $.getJSON('/pp?flow=UKCallCreditAgeVerify', {
            am: amount,
            cu: currency,
            paymentMethod: paymentmethod
        }, function(data) {
            if(typeof callback === 'function'){
                callback(data);
            }
            $.ajaxSetup({
                async: true
            });
        });
    }

    window.ageverify = {
        verifyAgeForUKPlayer: verifyAgeForUKPlayer
    };

    return window.ageverify;
});

